import React from 'react'
import { ButtonBox, BUTTON_BOX_SIZE } from '@defign/ui'
import className from 'classnames/bind'

import style from './MyhouseLoanRecommend.module.scss'

import { NCLICK } from '@Root/contants/lcs'
import { handleNclick } from '@Helpers/nclick'
import IconInfo from '@Ui/images/myhouse/IconInfo'
import { TRADE } from '@Root/contants'

import '@defign/ui/dist/defign.css'

const cx = className.bind(style)

const LOAN_RECOMMEND_CONTENTS_MAP = {
  [TRADE.LEASE]: {
    title: '곧 전세 계약 만기입니다.',
    description: (
      <>
        이사 예정이신가요?
        <br />
        나에게 맞는 전세대출을 알아보세요.
      </>
    ),
    buttonTitle: `맞춤 전세대출보증 조회하기`,
    buttionClickCode: NCLICK.MY_HOUSE.LOAN_RECOMMEND.전세만기,
  },
  [TRADE.RENT]: {
    title: '곧 월세 계약 만기입니다.',
    description: (
      <>
        이사 예정이신가요?
        <br />
        나에게 맞는 보증금대출을 알아보세요.
      </>
    ),
    buttonTitle: '맞춤 상품 조회하기',
    buttionClickCode: NCLICK.MY_HOUSE.LOAN_RECOMMEND.월세만기,
  },
}

type Props = {
  houseNo: string
  tradeTypeCode?: TRADE.LEASE | TRADE.RENT
}

const MyhouseLoanRecommend = ({ houseNo, tradeTypeCode }: Props) => {
  if (!houseNo || !tradeTypeCode || ![TRADE.RENT, TRADE.LEASE].includes(tradeTypeCode)) {
    return null
  }

  return (
    <div className={cx('article')}>
      <div className={cx('inner')}>
        <strong className={cx('title')}>
          <span className={cx('icon')}>
            <IconInfo width={20} height={20} />
          </span>
          {LOAN_RECOMMEND_CONTENTS_MAP[tradeTypeCode].title}
        </strong>
        <div className={cx('item')}>
          <p className={cx('description')}>
            계약을 연장하셨거나 연장 예정이신 경우
            <br />
            만기일자를 수정해 주세요.
          </p>
          <div className={cx('button_area')}>
            <ButtonBox
              size={BUTTON_BOX_SIZE.LARGE_FULL}
              href={`${process.env.REACT_APP_LAND_WEB_URL}/myhouse/register/main/${houseNo}`}
              text="만기일자 수정하기"
              color="green"
              variant="secondary"
            />
          </div>
        </div>
        <div className={cx('item')}>
          <p className={cx('description')}>{LOAN_RECOMMEND_CONTENTS_MAP[tradeTypeCode].description}</p>
          <div className={cx('button_area')}>
            <ButtonBox
              size={BUTTON_BOX_SIZE.LARGE_FULL}
              href={process.env.REACT_APP_LOAN_RECOMMEND_HOME}
              onClick={(event: React.SyntheticEvent) =>
                handleNclick(LOAN_RECOMMEND_CONTENTS_MAP[tradeTypeCode].buttionClickCode, event)
              }
              text={LOAN_RECOMMEND_CONTENTS_MAP[tradeTypeCode].buttonTitle}
              color="green"
              variant="secondary"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default MyhouseLoanRecommend
